import { COLUMNS, rowsOf } from './model.js';
import { encodeCp1251, decodeCp1251 } from '../pn/cp1251.js';
const esc=s=>String(s??'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
const unesc=s=>s.replace(/&#(x[\da-f]+|\d+);/gi,(_,n)=>String.fromCodePoint(n[0].toLowerCase()==='x'?parseInt(n.slice(1),16):Number(n))).replace(/&apos;/g,"'").replace(/&quot;/g,'"').replace(/&gt;/g,'>').replace(/&lt;/g,'<').replace(/&amp;/g,'&');
const date=s=>s.slice(8,10)+s.slice(5,7)+s.slice(0,4);
export function buildOppXml(doc, docCnt=1) {
  const o=doc.org, rows=rowsOf(doc), el=(k,v)=>`<${k}>${esc(v)}</${k}>`;
  const head={TIN:o.tin,C_DOC:'J13',C_DOC_SUB:'120',C_DOC_VER:7,C_DOC_TYPE:0,C_DOC_CNT:docCnt,
    C_REG:o.reg,C_RAJ:o.raj,PERIOD_MONTH:Number(doc.fillDate.slice(5,7)),PERIOD_TYPE:1,PERIOD_YEAR:Number(doc.fillDate.slice(0,4)),C_STI_ORIG:o.sti,C_DOC_STAN:1};
  let xml='<?xml version="1.0" encoding="windows-1251"?>\n<DECLAR xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="J1312007.xsd"><DECLARHEAD>';
  xml+=Object.entries(head).map(([k,v])=>el(k,v)).join('')+'<LINKED_DOCS xsi:nil="true"/>'+el('D_FILL',date(doc.fillDate))+el('SOFTWARE','eTax')+'</DECLARHEAD><DECLARBODY>';
  xml+=el('HSTI',o.stiName)+el('HTIN',o.tin)+el('HNAME',o.name);
  for(const [key,,g] of COLUMNS) for(const [i,r] of rows.entries()) {
    const tag=`T1RXXXXG${g}${['sign','type','objectId','state','right','nonMain'].includes(key)?'':'S'}`;
    const value=key==='nonMain'?(r[key]?1:null):r[key];
    xml+=value==null||value===''?`<${tag} ROWNUM="${i+1}" xsi:nil="true"/>`:`<${tag} ROWNUM="${i+1}">${esc(value)}</${tag}>`;
  }
  xml+=el('HBOS',o.bos)+el('HFILL',date(doc.fillDate))+'</DECLARBODY></DECLAR>';
  const {bytes,bad}=encodeCp1251(xml);
  if(bad.length) throw new Error(`Символи не підтримуються формою: ${bad.join(' ')}`);
  return {xml,bytes};
}
// Бланк відтворює саме сформовані байти XML, а не поточні поля редактора.
export function parseOppXml(bytes) {
  const xml=typeof bytes==='string'?bytes:/encoding=["']utf-8["']/i.test(new TextDecoder().decode(bytes.slice(0,150)))?new TextDecoder().decode(bytes):decodeCp1251(bytes);
  const read=tag=>unesc(xml.match(new RegExp(`<${tag}\\b[^>]*>([\\s\\S]*?)</${tag}\\s*>`))?.[1]||'');
  const rows=new Map();
  for(const [key,,g] of COLUMNS) {
    const tag=`T1RXXXXG${g}${['sign','type','objectId','state','right','nonMain'].includes(key)?'':'S'}`;
    for(const m of xml.matchAll(new RegExp(`<${tag}\\b([^>]*?)(?:/>|>([\\s\\S]*?)</${tag}\\s*>)`, 'g'))) {
      const n=m[1].match(/\bROWNUM\s*=\s*["'](\d+)["']/)?.[1];if(!n)continue;
      const r=rows.get(Number(n))||{}; r[key]=unesc(m[2]||''); rows.set(Number(n),r);
    }
  }
  return {form:read('C_DOC')+read('C_DOC_SUB').padStart(3,'0')+read('C_DOC_VER').padStart(2,'0'),org:{tin:read('HTIN'),name:read('HNAME'),stiName:read('HSTI'),bos:read('HBOS')},fillDate:read('HFILL'),rows:[...rows].sort((a,b)=>a[0]-b[0]).map(x=>x[1])};
}
